<ion-header class="mss-header" [translucent]="true" *ngIf="showHeader">

    <ion-toolbar class="mss-main-toolbar-wrapper">
        <div class="xl-wrapper mss-main-toolbar">

            <div class="mss-main-toolbar-logo pointer" (click)="goHome()">
                <img src="assets/images/mss-icon-logo.png" alt="Logo">
                <div class="mss-main-toolbar-logo__text">
                    My Support Space
                </div>
            </div>
            <div class="mss-main-toolbar-links">
                <div class="mss-main-toolbar-link" (click)="goHome()" [ngClass]="isDiscoverPage ? 'mss-main-toolbar-link__active' : ''">
                    {{ lang.data['action.discover'] }}
                </div>
                <div class="mss-main-toolbar-link" (click)="goToMoodLog()" [ngClass]="isMoodLogPage ? 'mss-main-toolbar-link__active' : ''">
                    {{ lang.data['label.mood_log'] }}
                </div>
                <div class="mss-main-toolbar-link" (click)="openLiveChat()">
                    {{ lang.data['label.chat'] }}
                </div>
                <div class="mss-main-toolbar-link" *ngIf="crisisModeEnabled" (click)="goToCrisis()" [ngClass]="isCrisisPage ? 'mss-main-toolbar-link__active' : ''">
                    {{ lang.data['label.crisis'] }}
                </div>
                <div class="mss-main-toolbar-actions">
                    <div class="mss-main-toolbar-action divider-right" *ngIf="userService.isLoggedIn">
                        <div class="mss-main-toolbar-action__icon" (click)="logout()" title="Log out">
                            <ion-icon name="log-out-outline"></ion-icon>
                        </div>
                    </div>

                    <div class="mss-main-toolbar-action divider-right" *ngIf="!userService.isLoggedIn">
                        <div class="mss-main-toolbar-action__icon" (click)="goToLogin()" title="Log in">
                            <ion-icon name="log-in-outline"></ion-icon>
                        </div>
                    </div>

                    <div class="mss-main-toolbar-action divider-right" *ngIf="userService.isLoggedIn">
                        <div class="mss-main-toolbar-action__icon notification-bell" (click)="goToNotifications()" title="Notifications">
                            <ion-icon name="notifications-outline"></ion-icon>
                            <ion-badge *ngIf="notificationBadgeCount > 0" color="danger" class="notification-badge">
                                {{ notificationBadgeCount > 99 ? '99+' : notificationBadgeCount }}
                            </ion-badge>
                        </div>
                    </div>

                    <div class="mss-main-toolbar-action">
                        <div class="mss-main-toolbar-action__icon" (click)="goToAccount()">
                            <img alt="MySupportSpace Profile" src="assets/icons/profile_icon.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ion-toolbar>

    <app-mobile-header-banner *ngIf="showMobileHeader"></app-mobile-header-banner>

    <div class="close-app" (click)="closeApp()">
        <ion-title>
            {{ lang.data['action.close'] }}
        </ion-title>
    </div>
</ion-header>
